'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getInitialState = exports.setRequestDetailsOnClient = exports.setRequestDetailsOnServer = undefined;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

exports.default = reducer;

var _querystring = require('querystring');

var _cookie = require('cookie');

var _cookie2 = _interopRequireDefault(_cookie);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var UPDATE_REQUEST = 'classpass/request/UPDATE_REQUEST';

var setRequestDetailsOnServer = exports.setRequestDetailsOnServer = function setRequestDetailsOnServer(req) {
  return { type: UPDATE_REQUEST, req: req };
};
var setRequestDetailsOnClient = exports.setRequestDetailsOnClient = function setRequestDetailsOnClient() {
  return { type: UPDATE_REQUEST };
};

var getInitialState = exports.getInitialState = function getInitialState() {
  return {
    protocol: '',
    query: {},
    path: '',
    hostname: '',
    cookies: {},
    userAgent: ''
  };
};

function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : getInitialState();
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  switch (action.type) {
    case UPDATE_REQUEST:
      {
        if (__SERVER__) {
          var MobileDetect = require('mobile-detect');

          var req = action.req;
          if (req) {
            var device = new MobileDetect(req.get('user-agent'));
            var deviceType = void 0;

            if (device.phone()) {
              deviceType = 'phone';
            } else if (device.tablet()) {
              deviceType = 'tablet';
            } else if (!device.mobile()) {
              deviceType = 'desktop';
            } else {
              deviceType = 'unknown';
            }

            var _cookies = (0, _extends3.default)({}, _cookie2.default.parse(req.get('cookie') || ''), req.cookies);

            return {
              protocol: req.protocol,
              query: req.query,
              path: req.path,
              hostname: req.hostname,
              cookies: _cookies,
              visitorId: _cookies.cpVisitorId,
              deviceType: deviceType,
              userAgent: req.get('user-agent'),
              baseUrl: req.protocol + '://' + req.hostname + '/',
              currentFullUrl: req.protocol + '://' + req.hostname + req.originalUrl
            };
          }
        }

        var cookies = _cookie2.default.parse(document.cookie || '');

        return (0, _extends3.default)({}, state, {
          protocol: window.location.protocol.replace(/:$/, ''),
          query: window.location.search ? (0, _querystring.parse)(window.location.search.substr(1)) : {},
          path: window.location.pathname,
          hostname: window.location.host.replace(/:\d+$/, ''),
          cookies: cookies,
          userAgent: navigator.userAgent,
          baseUrl: window.location.protocol + '//' + window.location.host.replace(/:\d+$/, '') + '/',
          currentFullUrl: window.location.href,
          visitorId: cookies.cpVisitorId
        });
      }
    default:
      return state;
  }
}